import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const FeedbackFormContainer = styled(Container).attrs({ width: 'sm' })`
    margin-top: ${getPurpurSpacing('600')};
    margin-bottom: ${getPurpurSpacing('400')};
    min-height: 18rem;

    ${purpurMedia('lg')`
        margin-top: ${getPurpurSpacing('800')};
        margin-bottom: ${getPurpurSpacing('600')};
        min-height: 25rem;
    `};
`;

export const FeedbackDataForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};
    margin-top: ${getPurpurSpacing('400')};
`;

export const FeedbackPrivacyContainer = styled.div`
    color: ${getPurpurColor('textMedium')};
`;

export const FeedbackSubmitContainer = styled.div`
    margin-top: ${getPurpurSpacing('300')};
    display: flex;
    flex-direction: column;

    ${purpurMedia('md')`
        flex-direction: row;
    `};
`;

export const FeedbackNotificationContainer = styled.div`
    margin-top: ${getPurpurSpacing('400')};
    margin-bottom: ${getPurpurSpacing('600')};
`;
